import { z } from 'zod';
import { CertificationHolderTableColumns, CertificationHolderStatus } from './-constants';
export const CertificationHolderListTableFilterSchema = z.object({
  // ページネーション
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  // ソート
  sortColumn: z.nativeEnum(CertificationHolderTableColumns).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  // タブフィルタ
  certificationStatus: z.nativeEnum(CertificationHolderStatus).default(CertificationHolderStatus.ACTIVE),
  // フィルタ
  freeText: z.string().optional()
});
export type CertificationHolderListTableFilterType = z.infer<typeof CertificationHolderListTableFilterSchema>;